import React, { useState } from "react";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";
import { COMPANY } from "../lib/brand";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General Enquiry", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Thanks! We'll get back within 24 hours.");
      setForm({ name: "", email: "", phone: "", subject: "General Enquiry", message: "" });
    } catch { toast.error("Failed to send."); }
    finally { setLoading(false); }
  };
  return (
    <main className="pt-28 pb-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="ali-chip">Get In Touch</div>
        <h1 className="mt-4 font-satoshi font-black text-4xl sm:text-5xl text-[#0A192F] tracking-tight">Let's talk about your goals.</h1>
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="space-y-6">
            {[
              { i: Phone, t: "Call us", v: COMPANY.phone, href: `tel:${COMPANY.phoneTel}` },
              { i: Mail, t: "Email", v: COMPANY.email, href: `mailto:${COMPANY.email}` },
              { i: MapPin, t: "Visit", v: COMPANY.address, href: null },
            ].map((c, i) => (
              <div key={i} className="ali-card p-6" data-testid={`contact-info-${c.t}`}>
                <div className="w-10 h-10 rounded-xl bg-[#FF6B35]/10 text-[#FF6B35] grid place-items-center mb-3"><c.i className="w-5 h-5" /></div>
                <p className="text-xs uppercase tracking-widest text-slate-500 font-poppins">{c.t}</p>
                {c.href ? (
                  <a href={c.href} className="mt-1 block font-satoshi font-bold text-[#0A192F] hover:text-[#FF6B35] transition leading-snug">{c.v}</a>
                ) : (
                  <p className="mt-1 font-satoshi font-bold text-[#0A192F] leading-snug">{c.v}</p>
                )}
              </div>
            ))}
          </div>
          <form onSubmit={submit} className="lg:col-span-2 ali-card p-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Your name" className="rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-[#FF6B35]" data-testid="contact-name" />
            <input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="Email" className="rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-[#FF6B35]" data-testid="contact-email" />
            <input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="Phone (optional)" className="rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-[#FF6B35]" data-testid="contact-phone" />
            <select value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} className="rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-[#FF6B35]" data-testid="contact-subject">
              {["General Enquiry","Course Question","Study Abroad","Partnership","Career"].map(s => <option key={s}>{s}</option>)}
            </select>
            <textarea required value={form.message} onChange={e => setForm({...form, message: e.target.value})} rows={5} placeholder="Tell us a bit…" className="sm:col-span-2 rounded-xl border border-slate-200 px-4 py-3 outline-none focus:border-[#FF6B35]" data-testid="contact-message" />
            <button disabled={loading} className="sm:col-span-2 ali-btn-primary flex items-center justify-center gap-2" data-testid="contact-submit"><Send className="w-4 h-4" /> {loading ? "Sending…" : "Send Message"}</button>
          </form>
        </div>
      </div>
    </main>
  );
}
